// Approximate Bedrock token pricing for UI cost display. Loose numbers —
// for rough parenthetical "($0.10)" hints alongside generated output.
// Not billing. Mirrors the table in evals/summary-run.ts.
//
// Update when AWS changes prices. The `model` value is the full Bedrock
// model id (e.g. "us.anthropic.claude-sonnet-4-6") as it comes back from
// the summarize endpoint, so no normalization is needed.

const PRICES_PER_M_TOKENS: Record<string, { in: number; out: number }> = {
  "us.anthropic.claude-opus-5-5": { in: 4.4, out: 22 },
  "us.anthropic.claude-sonnet-5-5": { in: 2.2, out: 11 },
  "us.openai.gpt-6.1-sol": { in: 2.2, out: 11 },
  "us.openai.gpt-6-astra": { in: 11, out: 55 },
  "us.anthropic.claude-opus-5": { in: 5, out: 25 },
  "us.anthropic.claude-sonnet-5": { in: 3, out: 15 },
  "us.anthropic.claude-sonnet-4-6": { in: 3, out: 15 },
  "us.anthropic.claude-haiku-4-5-20251001-v1:0": { in: 0.8, out: 4 },
  "us.anthropic.claude-opus-4-7": { in: 15, out: 75 },
};

/** Return an estimated USD cost, or null if model is unknown or token
 *  counts are missing. Callers should render nothing on null. */
export function estimateBedrockCost(
  modelId: string,
  tokensIn: number | null,
  tokensOut: number | null,
): number | null {
  const p = PRICES_PER_M_TOKENS[modelId];
  if (!p || tokensIn == null || tokensOut == null) return null;
  return (tokensIn / 1_000_000) * p.in + (tokensOut / 1_000_000) * p.out;
}
